import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IframeNotificationService {

  constructor() {
    this.pingSize();
  }

  sendHeightEvent() {
    const height = document.body.offsetHeight;
    parent.postMessage({type: 'drk-rechner.iframe.resized', data: {height: height, id: 'lead-form'}}, '*');
  }

  pingSize() {
    this.sendHeightEvent();
    setTimeout(this.pingSize.bind(this), 1000);
  }
}
